<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-10">
        <div class="form-group">
          <input
            type="text"
            autofocus
            class="form-control"
            v-model="search"
            @input="(val) => searchChange(val)"
            :placeholder="$t(`site.search`)"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(active)="data">
            <a
              @click="makeSupervisor(data.item)"
              class="btn btn-success btn-sm"
              v-if="data.item.master_supervise == 0"
              >{{ $t("master.make_supervisor") }}</a
            >
            <a
              @click="makeSupervisor(data.item)"
              class="btn btn-danger btn-sm"
              v-else
              >{{ $t("master.un_make_supervisor") }}</a
            >
          </template>

          <template #cell(edit)="data">
            <b-button
              v-b-modal.modal-lg
              variant="outline-primary"
              @click="open(data.item)"
            >
              <i class="fa fa-graduation-cap"></i>
            </b-button>
          </template>
        </b-table>
        <hr />

        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>
        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
    <b-modal
      id="modal-lg"
      ok-only
      ok-title="Accept"
      centered
      size="lg"
      title="Large Modal"
    >
      <b-card-text>
        <b-table :stacked="($mobile==1)" 
          ref="masters"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :fields="fields"
          :items="masters"
        >
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                type="checkbox"
                v-model="recordIds"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span></span>
            </label>
          </template>
          <template #cell(status_id)="data"
            >{{ data.item.status[0].name }}
          </template>
          <template #cell(type_id)="data">{{ data.item.type.name }} </template>
          <template #cell(student_id)="data">
            <b-badge variant="light-warning">
              {{ data.item.student.full_name }}
            </b-badge>
          </template>
          <template #cell(supervisor)="data">
            <b-badge
              variant="light-primary"
              v-for="teacher in data.item.teachers"
              :key="teacher.id"
            >
              {{ teacher.full_name }}
            </b-badge>
          </template>

          <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />
        </b-table>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import controller from "../../../../Controllers/UsersController";
import config from "../../../../config/config";
import MasterTeachersController from "@/Controllers/MasterTeachersController";
import MastersController from "@/Controllers/MastersController";
var masterTeachersController = new MasterTeachersController();
export default {
  name: "UsersDataTable",
  props: ["items", "editItem"],
  data() {
    return {
      fields: [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "title",
          label: this.$i18n.t("master.title"),
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "student_id",
          label: this.$i18n.t("master.student"),
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "status_id",
          label: this.$i18n.t("master.status"),
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "type_id",
          label: this.$i18n.t("master.type"),
          sortable: true,
          sortDirection: "desc",
        },
      ],
      masters: [],
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "code",
            label: this.$i18n.t("students.academic_number"),
            sortable: true,
          },
          {
            key: "first_name",
            label: this.$i18n.t("students.first_name"),
            sortable: true,
          },
          {
            key: "last_name",
            label: this.$i18n.t("students.last_name"),
            sortable: true,
          },

          {
            key: "email",
            label: this.$i18n.t("users.email"),
            sortable: true,
          },

          {
            key: "active",
            label: this.$i18n.t("site.active"),
            sortable: true,
          },

          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
    };
  },
  async created() {
    this.masters = await new MastersController().GetAll({
      with: ["status", "teachers", "type", "student"],
    });
  },
  methods: {
    async open(item) {
      let mastres = await masterTeachersController.Masters({ id: item.id });
      console.log(mastres);
      this.recordIds = mastres.map((a) => a.id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.type = "teacher";

      apiParams.with = ["country"];
      //country_id
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    async makeSupervisor(data) {
      await masterTeachersController.MakeSupervisor({ id: data.id });
      this.$refs.table.refresh();
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>

